import { useEffect } from "react";
import { useLoaderData } from "react-router-dom";

import { inject } from "../../../../../../lib/itn-ui-kit/services/service-container";
import DynamicForm from "../../../../../components/modules/ClientDetail/Case/DynamicForm";
import InvalidContent from "../../../../../components/modules/ClientDetail/Case/DynamicForm/components/InvalidContent";
import { mapPermissions } from "../../../../../components/modules/ClientDetail/Case/utils/functions";
import { policyLayout } from "../../../../../components/modules/ClientDetail/Case/utils/layouts";
import { policyTransforms } from "../../../../../components/modules/ClientDetail/Case/utils/transformations";
import Navigation from "../../../../../components/navigations/client/detail/case/navigation";
import useParentLoaderData from "../../../../../hooks/useParentLoaderData";
import useService from "../../../../../hooks/useService";
import { NavigationHistoryService } from "../../../../../services/navigation-history-service";

export default () => {
  const { _case } = useParentLoaderData(2);
  const { clientPolicy, clientPolicyHistory } = useLoaderData();
  const currentUserService = inject("current-user-service");
  const clientPolicyRepository = useService("repositories/client-policy-repository");
  const userPermissions = currentUserService?.userRoles?.permissions || [];
  const canEdit = userPermissions.includes("casemanager.change_clientpolicy");
  const canView = userPermissions.includes("casemanager.view_clientpolicy");
  const mappedLayout = mapPermissions(policyLayout, canEdit);

  useEffect(() => {
    const navService = new NavigationHistoryService();
    navService.save("client-detail", "/case/policy-and-med-limits");
  }, []);

  return (
    <Navigation activeTab="policy-and-med-limits" _case={_case}>
      {canView ? (
        <DynamicForm
          formLayout={mappedLayout}
          historyData={clientPolicyHistory}
          data={clientPolicy}
          formRepository={clientPolicyRepository}
          fieldTransformRules={policyTransforms}
        />
      ) : (
        <InvalidContent />
      )}
    </Navigation>
  );
};
